import React from 'react'
import logo from '../assets/Clogo.png'

const ErrorPage = () => {
    return (

        <div className=' bg-transparent relative w-full h-full'>
              <img
                  className='object-cover justify-center items-center h-screen ml-10'
                src={logo}
                alt="logo"
              />
              <div className='absolute flex flex-col justify-center items-center top-0 right-0 left-40 bottom-0 font-bold animate-bounce'>
                   <div className=' text-9xl py-4'>404</div>
                     <div className='text-5xl mb-20'>Page Not Found</div>
                </div>
                </div>
      
    //     <div className='flex flex-col h-screen justify-center items-center font-sans text-black font-bold'>
    //    
         
    // </div>
  )
}

export default ErrorPage